import React from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import SBSLogoMark from "../../components/SBSLogoMark";
import { hasSysAdminCredential } from "./sysAdminAccess";

export default function SysAdminRoute({ children }) {
  const { currentUser, userData, loading } = useAuth() || {};

  if (loading) {
    return (
      <div className="sys-admin-route-page">
        <div className="sys-admin-route-card">
          <h1>Loading System Administration</h1>
          <p>Verifying SBS platform administrator access.</p>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/auth" replace />;
  }

  if (!hasSysAdminCredential(currentUser, userData)) {
    return (
      <div className="sys-admin-route-page">
        <div className="sys-admin-route-card">
          <SBSLogoMark className="sys-admin-route-badge" alt="" />
          <h1>System administrator access required</h1>
          <p>
            This area is reserved for approved Selenne Business Suite platform administrators.
            Company owner and company administrator roles do not grant access.
          </p>
          <div className="sys-admin-route-actions">
            <Link to="/admin">Company Control Center</Link>
            <Link to="/">Dashboard</Link>
          </div>
        </div>
      </div>
    );
  }

  return children;
}
